/** 导入/任务中心 WebSocket 与弹窗之间的进度同步 */
export const YIZHE_IMPORT_NOTIFY_EVENT = 'yizhe-import-notify';

export type ImportNotifyPayload = {
  message_id?: number;
  title?: string;
  message_type?: number;
  content?: {
    task_id?: number;
    success_count?: number;
    fail_count?: number;
    import_type?: number;
    jump_type?: number;
    import_progress?: number;
    notify_stage?: 'running' | 'done' | 'failed' | string;
    fail_msg?: string;
  };
};

export function dispatchImportNotifyEvent(payload: ImportNotifyPayload) {
  window.dispatchEvent(
    new CustomEvent<ImportNotifyPayload>(YIZHE_IMPORT_NOTIFY_EVENT, { detail: payload }),
  );
}
